"use client";
import PropTypes from "prop-types";
import React from "react";

import MegaMenu from "./megaMenu";
import MegaMenuShimmer from "./megaMenuShimmer";

/**
 * Component representing the desktop version of the mega menu.
 *
 * @param {object} props - The props passed to the component.
 * @param {array} props.data - The data representing the menu items (`menuJson`).
 * @returns {JSX.Element|null} DesktopMenu component.
 */
const Menu = ({ data, classes, isTopBanner }) => {
  const hasMenuItems = Boolean(data?.length);

  return (
    <div
      className={`border-grey-100 z-1 hidden grid-cols-1 gap-30 border-b border-t px-40 py-12 md:flex ${classes}`}
      data-testid="desktop-menu"
    >
      {hasMenuItems ? <MegaMenu menuItems={data} isTopBanner={isTopBanner} /> : <MegaMenuShimmer />}
    </div>
  );
};

Menu.propTypes = {
  classes: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      banners: PropTypes.array,
      categoryName: PropTypes.string,
      productCategoryId: PropTypes.string,
      parentProductCategoryId: PropTypes.string,
      childCategoryList: PropTypes.array,
    }),
  ).isRequired,
  isTopBanner: PropTypes.bool,
};

const DesktopMenu = React.memo(Menu);
export default DesktopMenu;
